import React from 'react';
import { Button } from '../../../FixedStyled';
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaTwitter,
  FaLinkedin
} from 'react-icons/fa';
import {
  FooterContainer,
  FooterSubscription,
  FooterSubText,
  FooterSubHeading,
  Form,
  FormInput,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkItems,
  FooterLinkTitle,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  SocialIcon,
  WebsiteRights,
  SocialIcons,
  SocialIconLink
} from './Footerstyle';
import Contactusingmui from '../../Contactussubfiles/Contactusingmui';

function Footer() {
  return (
    <FooterContainer>
      <FooterLinksContainer>
        <FooterLinksWrapper>
          <FooterLinkItems>
            <FooterLinkTitle>Quick Links</FooterLinkTitle>
            <FooterLink to='/services'>Events</FooterLink>
            <FooterLink to='/services'>Clubs</FooterLink>
            <FooterLink to='/'>Internship portal</FooterLink>
            <FooterLink to='/'>Testimonals</FooterLink>
          </FooterLinkItems>
          <FooterLinkItems>
            <FooterLinkTitle>Contact us</FooterLinkTitle>
            <FooterLink to='/contactpage'>Contact</FooterLink>
            <FooterLink to='/'>Github Org</FooterLink>
            
          </FooterLinkItems>
        </FooterLinksWrapper>
        <FooterLinksWrapper>
          <FooterLinkItems>
            <FooterLinkTitle>Others</FooterLinkTitle>
            <FooterLink to='/'>OSS Gallery</FooterLink>
            <FooterLink to='/'>e-Resources</FooterLink>
            
            <FooterLink to='/'>Omni Labs</FooterLink>
          </FooterLinkItems>
          <FooterLinkItems>
            <FooterLinkTitle>Address</FooterLinkTitle>
            <FooterLink to='/' style={{ fontSize:13}}>Kalasalingam Academy of Research and Education(KARE)</FooterLink>
            <FooterLink to='/'></FooterLink>
            <FooterLink to='/' style={{ fontSize: 13}}>Krishnankoil,TamilNadu.</FooterLink>
            
          </FooterLinkItems>
        </FooterLinksWrapper>
      </FooterLinksContainer>
      <SocialMedia>
        <SocialMediaWrap>
          <SocialLogo to='/'>
            kare oss
          </SocialLogo>
          <WebsiteRights>KARE OSS © 2022</WebsiteRights>
          <SocialIcons>
            <SocialIconLink href='https://www.facebook.com/KARE-Open-Source-Society-101987385740404' target='_blank' aria-label='Facebook'>
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink href='https://www.instagram.com/kare_oss/' target='_blank' aria-label='Instagram'>
              <FaInstagram />
            </SocialIconLink>
            <SocialIconLink
              href={
                'https://www.youtube.com/channel/UC-UIs4vPS16Z-GGggckOtZw/featured'
              }
              target='_blank'
              aria-label='Youtube'
            >
              <FaYoutube />
            </SocialIconLink>
            <SocialIconLink href='https://twitter.com/OssKare' target='_blank' aria-label='Twitter'>
              <FaTwitter />
            </SocialIconLink>
            <SocialIconLink href='https://www.linkedin.com/company/kareoss/' target='_blank' aria-label='LinkedIn'>
              <FaLinkedin />
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>
    </FooterContainer>
  );
}

export default Footer;